import * as React from "react";
import { CircularProgress as MuiCircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import styled from "@emotion/styled";

const CircularProgress = styled(MuiCircularProgress)`
  color: #192f67 !important;
`;
export default function Loader() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <CircularProgress />
    </Box>
  );
}
